import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=56ab97f7&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ab97f7"]])

export default __exports__